import { render } from "./QuarterlyAnalysis.vue?vue&type=template&id=763f2fc8&scoped=true"
import script from "./QuarterlyAnalysis.vue?vue&type=script&lang=js"
export * from "./QuarterlyAnalysis.vue?vue&type=script&lang=js"

import "./QuarterlyAnalysis.vue?vue&type=style&index=0&id=763f2fc8&scoped=true&lang=css"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763f2fc8"]])

export default __exports__